
export type IAnchor = {
  hash: string;
  title: string;
};
